module.exports = __webpack_public_path__ + "assets/img/TrendingNow_cruise2.ad3cb7fd-ps.jpg";